import { createContext, useContext } from 'react'
import { getConfig } from './config'

type AuthConfig = ReturnType<typeof getConfig>

type AuthConfigContextValue = {
  config: AuthConfig
  isEnabled: boolean
}

export const authConfig = getConfig()

export const AuthConfigContext = createContext<AuthConfigContextValue>({
  config: authConfig,
  isEnabled: Boolean(authConfig.domain && authConfig.clientId),
})

export function useAuthConfig() {
  return useContext(AuthConfigContext)
}
